import React, { FC } from "react";
import { Tooltip } from "@mantine/core";
import { StatusData } from "../types/StatusData";
import { ConvertJST } from "../utils/DateUtils";

export const StatusItem: FC<StatusData> = ({ timestamp, status }) => {
  return (
    <Tooltip label={ ConvertJST(new Date(timestamp), "YYYY/MM/DD HH:mm") }>
      <div
        style={{
          backgroundColor:
            status === "critical"
              ? "red"
              : status === "warning"
              ? "orange"
              : status === "maintenance"
              ? "#4169E1"
              : "#21AF63",
          borderRadius: 20,
          width: 8,
          height: 45,
        }}
      ></div>
    </Tooltip>
  );
};
